/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Section_Driver_DescriptionInputs */

const en_case_section_driver_description = /** @type {(inputs: Case_Section_Driver_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driver at the time of the incident.`)
};

const pt_br2_case_section_driver_description = /** @type {(inputs: Case_Section_Driver_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motorista no momento do sinistro.`)
};

/**
* | output |
* | --- |
* | "Driver at the time of the incident." |
*
* @param {Case_Section_Driver_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_section_driver_description = /** @type {((inputs?: Case_Section_Driver_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Section_Driver_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_section_driver_description(inputs)
	return pt_br2_case_section_driver_description(inputs)
});